
export default function Footer() {
  return (
    <footer className="py-16 px-8 md:px-16 lg:px-24 border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        {/* Navigation Buttons */}
        <div className="flex flex-wrap gap-4 justify-center mb-12">
          <a 
            href="https://luxas.jp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="px-6 py-3 bg-white text-gray-900 font-light tracking-wide rounded-sm hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            LUXASメインサイトへ行く
          </a>
          <a 
            href="https://portfolio1.luxas.jp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="px-6 py-3 border border-white/30 text-white font-light tracking-wide rounded-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            ポートフォリオ１へ行く
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-white/60 font-light tracking-wide">
            © 2025 LUXAS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
